// // Use $ instead of jQuery without replacing global $
(function ($) {

  $(window).on("load", function () {
    $('.product-model-slider').css({"opacity": 1});
  });

  $(document).ready(function () {

    var model_count = $('.modal_region').length;
    if (model_count === 1) {
      setTimeout(function () {
        $('.product-model-slider .slider').slick({
          arrows: true,
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          draggable: false,
          speed: 800,
          dots: true,
          prevArrow: $('.product-model-slider .slide-nav .slide-prev'),
          nextArrow: $('.product-model-slider .slide-nav .slide-next'),
          responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              }
            },
            {
              breakpoint: 595,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
          ]
        });
      }, 1500);
    } else {
      $('.product-model-slider .slider').slick({
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        draggable: false,
        speed: 800,
        dots: true,
        prevArrow: $('.product-model-slider .slide-nav .slide-prev'),
        nextArrow: $('.product-model-slider .slide-nav .slide-next'),
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            }
          },
          {
            breakpoint: 595,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
        ]
      });
    }

    var model_slider_image = $('.product-model-slider .slider-wrap .slider .item .bg-img img');
    objectFitImages(model_slider_image);
  });
})(jQuery);